module.exports = __webpack_public_path__ + "static/img/channel_banner2.e708cd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/channel_banner2.png
// module id = apkc
// module chunks = 0